module.exports = __webpack_public_path__ + "img/icon-mail.b7a3bd85.svg";